<template>
<div class="login-tips-bar">
  {{tipsText}}，请<a @click.stop="toMediaLogin">点击此处</a>注册登录
</div>
</template>

<script>
export default {
  name: "LoginTipsBar",
  props: {
    tipsText: {
      type: String,
      default() {
        return null;
      }
    }
  },
  methods: {
    toMediaLogin() {
    // &redirectUrl=${redirectUrl}
      const redirectUrl = encodeURIComponent(this.$route.path);
      this.$router.push("/Rccl.CustomPage/MediaCenter/MediaLogin?redirectUrl="+redirectUrl);
    }
  }
}
</script>

<style lang="less" scoped>
.login-tips-bar {
  height: 29px;
  line-height: 29px;
  color: #545a6f;
  text-align: center;
  font-size: .7rem;
  
  & a {
    text-decoration: underline;
    color: #00116f;
  }
}
</style>
